import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import { ExportValue } from "./ExportValue";
import { Feature } from "ol";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";

/**
 * 画面幅
 */
const VALUE_WIDTH = 470;

/**
 * 画面高さ
 */
const VALUE_HEIGHT = 320;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "cong_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "cong_yyyyMMdd_HHmmss.csv";

/**
 * 主要渋滞箇所属性変換用クラス
 */
export class TrafficCongestionAttributeConvert implements IAttributeConvert {
  /**
   * 地物
   */
  feature: Feature;

  /**
   * 属性画面タイトル
   */
  title: string;

  constructor(feature: Feature) {
    this.feature = feature;
    this.title = `主要渋滞箇所`;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FeatureType.TrafficCongestion;
  }

  /**
   * 画面用フォーマット取得
   */
  getViewFormatData(): AttributeView {
    const properties = this.feature.getProperties();

    // 画面項目定義リスト
    const items = [
      {
        key: "主要渋滞箇所名",
        value:
          (properties["主要渋滞箇所名（市区町村名）"] || "") +
          properties["主要渋滞箇所名（区間名・交差点名）"],
        isSimple: true,
      },
    ];
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues: AttributeValue[] = [];
    items.forEach((item) => {
      attributeValues.push(
        new AttributeValue(
          item.key,
          item.value ? item.value.toString() : null,
          item.isSimple
        )
      );
    });
    const attributeView = new AttributeView(
      attributeValues,
      this.title,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      VALUE_HEIGHT,
      null,
      true,
      true
    );
    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = this.feature.clone();
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
